module.exports = __webpack_public_path__ + "img/banner.ddf878a2.png";